import { render, staticRenderFns } from "./RankingMobile.vue?vue&type=template&id=042ea828&"
import script from "./RankingMobile.vue?vue&type=script&lang=js&"
export * from "./RankingMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports